/**
 * Progress Counter — Frontend animation
 *
 * Uses IntersectionObserver to trigger the animation when the block
 * enters the viewport. The animation sequence:
 *
 * 1. "Já temos" fades in.
 * 2. The number counts from 0 → target over countDuration.
 * 3. "kW instalados." slides up.
 * 4. Short pause.
 * 5. "Conseguimos" fades in.
 * 6. The ? scales up slightly and gently pulses.
 *
 * Timeline driven by JS; CSS transitions handle the visual easing.
 */

(function () {
    'use strict';

    function animateCounter(el) {
        if (el.dataset.pcAnimated === 'true') return;
        el.dataset.pcAnimated = 'true';

        var prefix = el.querySelector('.progress-counter__prefix');
        var numberEl = el.querySelector('.progress-counter__number');
        var suffix = el.querySelector('.progress-counter__suffix');
        var question = el.querySelector('.progress-counter__question');
        var qMark = el.querySelector('.progress-counter__question-mark');

        var target = parseInt(el.dataset.pcTarget, 10) || 45;
        var countDuration = parseFloat(el.dataset.pcCountDuration) || 1.8;
        var pauseDuration = parseFloat(el.dataset.pcPauseDuration) || 0.6;

        // Convert to milliseconds
        var countMs = countDuration * 1000;
        var pauseMs = pauseDuration * 1000;

        // Step 1 — fade in prefix (CSS transition handles it)
        requestAnimationFrame(function () {
            if (prefix) prefix.classList.add('pc-visible');
        });

        // Step 2 — count up after a short delay so the prefix is readable
        var countDelay = 400;
        setTimeout(function () {
            var startTime = null;
            var startValue = 0;

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                var elapsed = timestamp - startTime;
                var progress = Math.min(elapsed / countMs, 1);

                // Ease-out cubic for a natural deceleration
                var eased = 1 - Math.pow(1 - progress, 3);
                var current = Math.round(startValue + (target - startValue) * eased);

                if (numberEl) numberEl.textContent = current;

                if (progress < 1) {
                    requestAnimationFrame(step);
                } else {
                    // Step 3 — slide up suffix
                    if (suffix) suffix.classList.add('pc-visible');

                    // Step 4 — pause, then reveal question
                    setTimeout(function () {
                        if (question) question.classList.add('pc-visible');
                        // Step 5 — pulse the question mark after it appears
                        setTimeout(function () {
                            if (qMark) qMark.classList.add('pc-pulse');
                        }, 300);
                    }, pauseMs);
                }
            }

            requestAnimationFrame(step);
        }, countDelay);
    }

    function init() {
        var blocks = document.querySelectorAll('.progress-counter');
        if (!blocks.length) return;

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            animateCounter(entry.target);
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 0.35 }
            );
            blocks.forEach(function (block) {
                observer.observe(block);
            });
        } else {
            // Fallback: animate immediately
            blocks.forEach(function (block) {
                animateCounter(block);
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
